import { Snackbar, Alert } from "@mui/material";
import { useState } from "react";

export default function SnackBar({ handleCloseSnackbar, snackbar, anchorOrigin }) {
	const [open, setOpen] = useState(snackbar.open);
	return (
		<Snackbar
			open={snackbar.errorType === "useQuery" ? open : snackbar.open}
			anchorOrigin={anchorOrigin ?? { vertical: 'top', horizontal: 'right' }}
			{...(snackbar.processing ? {} : { autoHideDuration: 3000 })}
			onClose={() => {
				snackbar.errorType === "useQuery" ? setOpen(false) : handleCloseSnackbar();
			}}
			sx={{ height: "20%" }}>
			<Alert
				severity={snackbar?.type ?? 'error'}
				variant='filled'
				sx={{ width: "100%", fontSize: "15px" }}>
				{snackbar.message}
			</Alert>
		</Snackbar>
	);
}
